import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Label} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

import {StyledLink, FooterFlex} from "./styled"

const SelfSignUpFooter: FC = () => {
  const theme = useTheme()
  const {formatMessage} = useIntl()
  return (
    <FooterFlex justifyContent="space-between" alignItems="center" padding="0 16px">
      <Label color={theme.colors.greys.white}>
        <FormattedMessage id="platform.footer.copy.copyright.text" />
      </Label>
      <Flex gap={1}>
        <Label color={theme.colors.greys.white}>
          <StyledLink href={formatMessage({id: "platform.selfSignUp.footer.cookiesLink"})} target="_blank">
            <FormattedMessage id="platform.selfSignUp.footer.cookies" />
          </StyledLink>
        </Label>
        <Label color={theme.colors.greys.white}>
          <StyledLink href={formatMessage({id: "platform.selfSignUp.footer.privacyLink"})} target="_blank">
            <FormattedMessage id="platform.selfSignUp.footer.privacy" />
          </StyledLink>
        </Label>
      </Flex>
    </FooterFlex>
  )
}

export default SelfSignUpFooter
